import {
  selectFiscalInterestBalanceList,
  selectFiscalInterestBalanceListCount,
  selectFiscalInterestBalanceQueryOptions,
  selectAccountingInterestBalanceList,
  selectAccountingInterestBalanceListCount,
  selectAccountingInterestBalanceQueryOptions
} from 'src/store/selectors/interestBalanceSelectors';
import {
  loadFiscalInterestBalance,
  LOAD_FISCAL_INTEREST_BALANCE,
  CLEAR_FISCAL_INTEREST_BALANCE,
  downloadExcelFiscalInterestBalance,
  loadAccountingInterestBalance,
  LOAD_ACCOUNTING_INTEREST_BALANCE,
  CLEAR_ACCOUNTING_INTEREST_BALANCE,
  downloadExcelAccountingInterestBalance
} from 'src/store/actions/interestBalanceActions';

export const fiscalInterestBalanceConfig = {
  selectors: {
    selectList: selectFiscalInterestBalanceList,
    selectCount: selectFiscalInterestBalanceListCount,
    selectQueryOptions: selectFiscalInterestBalanceQueryOptions
  },
  actions: {
    load: loadFiscalInterestBalance,
    downloadExcel: downloadExcelFiscalInterestBalance
  },
  loadActionType: LOAD_FISCAL_INTEREST_BALANCE,
  clearActionType: CLEAR_FISCAL_INTEREST_BALANCE,
  titleKey: 'NAVIGATION.FISCAL_INTEREST_BALANCE',
  notFoundTitle: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_INTEREST_TITLE',
  notFoundDescription: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_INTEREST_DESCRIPTION'
};

export const accountingInterestBalanceConfig = {
  selectors: {
    selectList: selectAccountingInterestBalanceList,
    selectCount: selectAccountingInterestBalanceListCount,
    selectQueryOptions: selectAccountingInterestBalanceQueryOptions
  },
  actions: {
    load: loadAccountingInterestBalance,
    downloadExcel: downloadExcelAccountingInterestBalance
  },
  loadActionType: LOAD_ACCOUNTING_INTEREST_BALANCE,
  clearActionType: CLEAR_ACCOUNTING_INTEREST_BALANCE,
  titleKey: 'NAVIGATION.ACCOUNTING_INTEREST_BALANCE',
  notFoundTitle: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_INTEREST_TITLE',
  notFoundDescription: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_INTEREST_DESCRIPTION'
};
